import styled from 'styled-components';

const TooltipImg = styled.img`
    height: 20px;
    width: 20px;
    opacity: 0.3;
`;

export default TooltipImg;
